import * as React from 'react';
import Button from './Button';
/**
 * Icons as interactive buttons / links. It has the same props list as [Button component](/docs/components-shapeicon--docs)
 *
 * `✅ Stable`
 */
const IconButton = React.forwardRef(({ as = 'a', color = 'primary', variant = 'solid', radius = 'normal', size = 'medium', children, disabled = false, extraClasses, onClick, }, ref) => {
    const props = { color, variant, radius, size, children, disabled, extraClasses, onClick };
    if (as !== 'a' && as !== 'button') {
        throw new Error(`IconButton must be rendered as <a> or <button>. It is currently rendered as ${as}`);
    }
    return <Button icon as={as} {...props} data-clad="Icon Button" ref={ref}/>;
});
export default IconButton;
